import React from 'react'
import { cn } from "../../../../lib/utils";

export default function TD({children, className, ...props}) {
  return (
    <td className={cn(`py-3 border-b border-b-success-100 td-item`, className)} {...props}>{children}</td>
  )
}
